import type { WallDefinition } from "./wallDefinitions";
import { PRICE_WALL_BALANCE_PROFILE } from "./wallBalanceProfiles";
import {
  DEFAULT_WALL_REWARD_CAP_LEVEL,
  type WallRewardCapLevel,
} from "./wallRewardCap";

export const PRICE_WALL_DEFINITION: WallDefinition = {
  id: "price-wall",
  firstClearReward: PRICE_WALL_BALANCE_PROFILE.firstClearReward,
};

const PRICE_WALL_REWARD_MIN_MULTIPLIER =
  PRICE_WALL_BALANCE_PROFILE.reward.minimumMultiplier;
export const PRICE_WALL_REWARD_BASE_CAP_MULTIPLIER =
  PRICE_WALL_BALANCE_PROFILE.reward.caps.base;
export const PRICE_WALL_REWARD_RELAXED_CAP_MULTIPLIER =
  PRICE_WALL_BALANCE_PROFILE.reward.caps.relaxed;
const PRICE_WALL_REWARD_TARGET_CLEAR_MS =
  PRICE_WALL_BALANCE_PROFILE.reward.targetClearMs;
const PRICE_WALL_REWARD_FAST_CLEAR_MS =
  PRICE_WALL_BALANCE_PROFILE.reward.fastClearMs;
const PRICE_WALL_REWARD_TARGET_MULTIPLIER =
  PRICE_WALL_BALANCE_PROFILE.reward.targetMultiplier;
const PRICE_WALL_REWARD_CURVE_RANGE =
  PRICE_WALL_BALANCE_PROFILE.reward.curveRange;
const PRICE_WALL_REWARD_CURVE_EXPONENT =
  PRICE_WALL_BALANCE_PROFILE.reward.curveExponent;

export function resolvePriceWallRewardEffectiveMaxMultiplier(
  capLevel: WallRewardCapLevel = DEFAULT_WALL_REWARD_CAP_LEVEL,
): number {
  return capLevel === "relaxed"
    ? PRICE_WALL_REWARD_RELAXED_CAP_MULTIPLIER
    : PRICE_WALL_REWARD_BASE_CAP_MULTIPLIER;
}

export function resolvePriceWallRewardMultiplier(
  bestClearMs: number | null,
  effectiveMaxMultiplier: number = resolvePriceWallRewardEffectiveMaxMultiplier(),
): number {
  if (bestClearMs === null) return 1;
  if (!Number.isFinite(bestClearMs) || bestClearMs <= 0) {
    return effectiveMaxMultiplier;
  }

  if (bestClearMs > PRICE_WALL_REWARD_TARGET_CLEAR_MS) {
    return PRICE_WALL_REWARD_MIN_MULTIPLIER;
  }

  const progress =
    Math.log(PRICE_WALL_REWARD_TARGET_CLEAR_MS / bestClearMs) /
    Math.log(
      PRICE_WALL_REWARD_TARGET_CLEAR_MS / PRICE_WALL_REWARD_FAST_CLEAR_MS,
    );

  const raw =
    PRICE_WALL_REWARD_TARGET_MULTIPLIER +
    PRICE_WALL_REWARD_CURVE_RANGE *
      Math.pow(progress, PRICE_WALL_REWARD_CURVE_EXPONENT);

  return Math.min(
    effectiveMaxMultiplier,
    Math.max(PRICE_WALL_REWARD_MIN_MULTIPLIER, Math.round(raw)),
  );
}
